import { DailyMealValue, MealSlot } from '../models/meal.model';

export abstract class MealsRepository {
  abstract loadDate(date: string): Promise<MealSlot[]>;
  abstract loadRange(startDate: string, endDate: string): Promise<DailyMealValue[]>;
  abstract loadSuggestions(): Promise<string[]>;
  abstract saveMeal(date: string, axisId: number, meal: string): Promise<void>;
  abstract clearMeal(date: string, axisId: number): Promise<void>;
}
